import { render, staticRenderFns } from "./SearchResultsBulkActions.vue?vue&type=template&id=0086f5b0"
import script from "./SearchResultsBulkActions.vue?vue&type=script&lang=js"
export * from "./SearchResultsBulkActions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports